import { FC, ReactNode } from 'react';
import { PanelStyles } from './styles';

interface PanelProps {
	isOpen?: boolean;
	children: ReactNode;
	height?: string;
	mediaHeight?: boolean;
	maxHeight?: string;
	includePadding?: boolean;
	roundedBorders?: boolean;
	background?: string;
  minusHeight?:string;
}

export const Panel: FC<PanelProps> = ({
	isOpen = true,
	children,
	height,
	mediaHeight = true,
	maxHeight = '',
	includePadding = true,
	roundedBorders = false,
	background,
  minusHeight
}) => {
	return (
		<PanelStyles
			$isOpen={isOpen}
			$height={height}
			$mediaHeight={mediaHeight}
			$maxHeight={maxHeight}
			$includePadding={includePadding}
			$roundedBorders={roundedBorders}
			$background={background}
      $minusHeight={minusHeight}
		>
			{children}
		</PanelStyles>
	);
};
